import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsUploadStep1Component } from './upload/documents/step1/documents-upload-step1.component';
import { UploadComponent } from './upload/upload.component';
import { UploadRoutingModule } from './upload-routing.module';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { TranslateModule } from '../../services/translate/translate.module';
import { DocumentsUploadStep2Component } from './upload/documents/step2/documents-upload-step2.component';
import { UtilitiesService } from '../../services/utils/utilities.service';
import { DocumentsUploadStep3Component } from './upload/documents/step3/documents-upload-step3.component';
import { DocumentsUploadStep4Component } from './upload/documents/step4/documents-upload-step4.component';
import { SuppliersUploadStep1Component } from './upload/suppliers/step1/suppliers-upload-step1.component';
import { SuppliersUploadStep2Component } from './upload/suppliers/step2/suppliers-upload-step2.component';
import { SuppliersUploadStep3Component } from './upload/suppliers/step3/suppliers-upload-step3.component';
import { SuppliersUploadStep4Component } from './upload/suppliers/step4/suppliers-upload-step4.component';
import { UploadSuppliersInstructionsModalComponent } from './upload/suppliers/instructions-modal/upload-suppliers-instructions-modal.component';
import { UploadSuppliersInstructionsComponent } from './upload/suppliers/instructions/upload-suppliers-instructions-component';
import { FactoringCreditAssignmentTemplateComponent } from './upload/FactoringCreditAssignment/template/factoring-credit-assignment-template.component';
import { UploadFileComponent } from './upload/files/upload-file.component';
import { DocumentsUploadConfirmingInstructionsComponent } from './upload/documents/confirming/instructions/documents-upload-instructions.component';
import { DocumentsUploadConfirmingValidationResultComponent } from './upload/documents/confirming/validation-result/documents-upload-validation-result.component';
import { DocumentsUploadFactoringInstructionsComponent } from './upload/documents/factoring/instructions/documents-upload-instructions.component';
import { DocumentsUploadFactoringValidationResultComponent } from './upload/documents/factoring/validation-result/documents-upload-validation-result.component';
import { DocumentsUploadInstructionsModalComponent } from './upload/documents/instructions-modal/instructions-modal.component';
import { FileUploadModule } from '../../shared-components/file-upload/file-upload.module';
import { CustomStepperModule } from '../../shared-components/custom-stepper/custom-stepper.module';
import { SuppliersUploadValidationResultComponent } from './upload/suppliers/validation-result/suppliers-upload-validation-result.component';
import { ContractsInCompanyModule } from '../../shared-components/contracts-in-company/contracts-in-company.module';
import { UploadDocumentsApiService } from '../../server-api/upload-documents-api/upload-documents-api.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		CoreModule,
		TranslateModule,
		UploadRoutingModule,
		FileUploadModule,
		CustomStepperModule,
		ContractsInCompanyModule,
	],
	declarations: [
		UploadComponent,
		DocumentsUploadStep1Component,
		DocumentsUploadStep2Component,
		DocumentsUploadStep3Component,
		DocumentsUploadStep4Component,
		SuppliersUploadStep1Component,
		SuppliersUploadStep2Component,
		SuppliersUploadStep3Component,
		SuppliersUploadStep4Component,
		UploadSuppliersInstructionsModalComponent,
		UploadSuppliersInstructionsComponent,
		SuppliersUploadValidationResultComponent,
		FactoringCreditAssignmentTemplateComponent,
		UploadFileComponent,
		DocumentsUploadConfirmingInstructionsComponent,
		DocumentsUploadConfirmingValidationResultComponent,
		DocumentsUploadFactoringInstructionsComponent,
		DocumentsUploadFactoringValidationResultComponent,
		DocumentsUploadInstructionsModalComponent,
	],
	providers: [UtilitiesService, UploadDocumentsApiService],
})
export class UploadModule {}
